import { Configuration } from "Models/configuration";
import { Message } from "Models/message";
import { Producer } from "Models/producer";
import { setProducer } from "Redux/actions";
import {
    getCurrentTick,
    getProducer as getProducerState,
} from "Redux/selectors";
import store, { dispatch } from "Redux/store";
import { Subscription } from "rxjs";
import { addMessage } from "./logs.service";
import { mainTimeline$ } from "./timeline.service";
import {
    getActiveLeads,
    getActiveReplicas,
    getAllPartitions,
} from "./partitions.service";
import { takeEvery } from "./utils/take-every";
import { v4 as uuidv4 } from "uuid";

let producerSub$: Subscription;

export const getProducer = () => getProducerState(store.getState());

export const setupProducer = (
    { producerInterval }: Partial<Configuration>,
    existingProducer: Producer
): Producer => ({
    ...existingProducer,
    interval: producerInterval ?? 1,
    counter: existingProducer?.counter ?? 0,
});

export const startProducer = (producer: Producer) => {
    stopProducer();
    producerSub$ = mainTimeline$
        .pipe(takeEvery(producer.interval))
        .subscribe(() => {
            produce();
        });
};

export const stopProducer = () => {
    if (producerSub$) producerSub$.unsubscribe();
};

export const produce = () => {
    const partitions = getAllPartitions();
    const leads = getActiveLeads(partitions);
    const producer = getProducer();
    const replicas = getActiveReplicas(partitions);

    const randomLead = Math.floor(Math.random() * leads.length);
    const targetLead = leads.splice(randomLead, 1)?.shift();

    if (!targetLead) return;

    const counter = producer.counter + 1;
    const msg: Message = {
        uid: uuidv4(),
        originUid: null,
        id: counter,
        value: counter.toString(),
        tick: getCurrentTick(store.getState()),
        partitionId: targetLead.id,
    };

    const leadMessage = addMessage(targetLead.logUid, msg);
    replicas
        .filter((r) => r.id === targetLead.id)
        .forEach((r) => addMessage(r.logUid, leadMessage));

    dispatch(
        setProducer({
            ...producer,
            counter,
            recentMessage: msg,
        })
    );
};
